/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import StatsCard from "../../Cards/statsCard";
import { CARD_GAP, REFETCH_CONFIGURATION } from "../../../utils/constants";
import SiteMonitoredChart from "../../Charts/SiteMonitored";
import LoadProfileChart from "../../Charts/LoadProfileChart";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useEffect, useState } from "react";
import SitePerformanceTable from "../../Table/SitePerformanceTabe";
import ThresholdTable from "../../Table/ThresholdTable";
import PowerConsumptionBySite from "../../Charts/PowerConsumptionBySite";
import SiteLocationMap from "../Manager/Map";
import { formatCustomDateDayMonthYear } from "../../../utils/utils";
import { useUtils } from "../../../customHooks/useUtils";
import { resetFilter } from "../../../store/filterSlice";
import Loader from "../../feedBacks/loader";

function Operations({ company_id }: { company_id: string }) {
  const dispatch = useAppDispatch();
  const [isFilterReset, setIsFilterReset] = useState(false);

  useEffect(() => {
    const resetFilters = async () => {
      try {
        await dispatch(resetFilter());
        setIsFilterReset(true);
      } catch (error) {
        console.error("Error resetting filters:", error);
        // Still allow rendering even if reset fails
        setIsFilterReset(true);
      }
    };

    resetFilters();
  }, [dispatch]);

  const { FEEDBACK_MESSAGES, INSTATAENOUS_KPIS } = useUtils();
  const { mapResponseToLabelValue, t } = useUtils();
  const excludeCards = [t("readings.unknown")];
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);
  const language = useAppSelector((state) => state.language.language);

  const {
    data: operationsData,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData(
    ["/operations", "fetchOperations", company_id],
    "/operations/cards-data",
    {
      card_type: "operations_home",
      company_id,
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
      // Only enable query if filter has been reset
      enabled: isFilterReset,
    }
  );

  const isLoading =
    // Show loading for initial page load
    isDataLoading ||
    // Show loading when filter is applied and when actually refetching
    isLocalLoading ||
    // Show loading while filter is being reset
    !isFilterReset;

  useEffect(() => {
    if (startDate && endDate && isFilterReset) {
      setIsLocalLoading(true);

      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [startDate, endDate, refetch, isFilterReset]);

  // Don't render the main content until filter reset is complete
  if (!isFilterReset) {
    return (
      <div className="flex justify-center items-center w-full h-64">
        <Loader/>
      </div>
    );
  }

  const transformedData = operationsData
    ? mapResponseToLabelValue(operationsData)
    : [];

  return (
    <div
      className="flex flex-col items-start justify-center w-full"
      style={{ gap: CARD_GAP }}
    >
      {/* stats wrapper */}
      <div
        className="grid w-full"
        style={{
          gap: CARD_GAP,
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        }}
      >
        {isLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <StatsCard
                key={index}
                title=""
                value=""
                isError={false}
                isLoading={true}
              />
            ))
          : error
          ? (error as any).response.data.detail
            ? Array.from({ length: 4 }).map((_, index) => (
                <StatsCard
                  key={index}
                  title=""
                  value=""
                  errorType={FEEDBACK_MESSAGES.NO_DEVICE}
                  isError={true}
                  isLoading={false}
                  cardErrorStyle="!h-[50px]"
                />
              ))
            : Array.from({ length: 4 }).map((_, index) => (
                <StatsCard
                  key={index}
                  title=""
                  value=""
                  isError={true}
                  isLoading={false}
                  cardErrorStyle="!h-[50px]"
                />
              ))
          : transformedData &&
            transformedData.map(
              (data: any, index: any) =>
                !excludeCards.includes(data.label) && (
                  <div key={index}>
                    <StatsCard
                      title={data.label}
                      value={data.value as string}
                      time={
                        INSTATAENOUS_KPIS.includes(data.label)
                          ? (operationsData as any).time
                          : ""
                      }
                      period={
                        !INSTATAENOUS_KPIS.includes(data.label)
                          ? formatCustomDateDayMonthYear(
                              startDate,
                              endDate,
                              language
                            )
                          : ""
                      }
                      isError={!!error && !isLoading && !data}
                      isLoading={isLoading}
                    />
                  </div>
                )
            )}
      </div>
      <div className="flex flex-col  justify-center w-full min-h-[350px]">
        <SiteLocationMap company_id={company_id} />
      </div>
      {/* chats wrapper */}
      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <LoadProfileChart
          params={{ company_id }}
          route="/operations/profile-chart"
          queryKey={["/operations", "fetchLoadProfile", company_id]}
          title={t("chart.load_profile")}
        />
      </div>
      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <SiteMonitoredChart company_id={company_id} />
        <PowerConsumptionBySite
          company_id={company_id}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      <div
        className="flex flex-col lg:flex-row flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <SitePerformanceTable company_id={company_id} />
        <ThresholdTable company_id={company_id} />
      </div>
    </div>
  );
}

export default Operations;
